import ProfilesService from 'top20common/distribution/services/profiles';

export default {
  getProfileOptionsAction(context) {
    context.commit('setProfileOptionsLoadingState', true);
    return new Promise((resolve, reject) => {
      ProfilesService.getProfileOptions()
        .then(response => {
          let genders = response.data.genders ? objectToArray(response.data.genders) : [];
          let qualifications = response.data.qualifications ? objectToArray(response.data.qualifications) : [];

          context.commit('setProfileOptionsLoadingState', false);
          context.commit('setProfileOptionsState', {
            ...response.data,
            genders,
            qualifications
          });
          resolve(response);
        })
        .catch(() => {
          context.commit('setProfileOptionsLoadingState', false);
        });
    });
  },
  getJobTitlesByIndustryAction(context, industry) {
    context.commit('setJobTitlesOptionsLoadingState', true);
    return new Promise((resolve, reject) => {
      ProfilesService.getJobTitles(industry).then(response => {
        context.commit('setJobTitlesOptionsLoadingState', false);
        context.commit('setJobTitlesOptionsState', response.data.results);
        resolve();
      });
    });
  },
  updateBasicProfileInfoAction(context, data) {
    context.commit('mutateEditProfileLoadingState', true);
    return new Promise((resolve, reject) => {
      ProfilesService.updateBasicProfileInfo(data)
        .then(response => {
          context.commit('mutateEditProfileLoadingState', false);
          context.commit('mutateProfileCompletenessState', response.data.meta);
          resolve(response.data.result);
        })
        .catch(error => {
          context.commit('mutateEditProfileLoadingState', false);
          reject(error.response.data.errors);
        });
    });
  }
};

function objectToArray(obj) {
  return Object.keys(obj).map(key => {
    return {
      slug: key,
      name: obj[key]
    };
  });
}
